import type { BookingsOverviewState, BookingsOverviewStore } from '@/scopes/account/bookings-overview/domain/types'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { createStore } from 'zustand'

const defaultInitialState: BookingsOverviewState = {
  cancelledBookings: {},
  pastBookings: {},
  bookingHistoryActiveTab: 'past',
  bookingOverviewPageLoadStatus: 'idle',
}

export const bookingsOverviewStore = createBookingsOverviewStore()

export function createBookingsOverviewStore(initialState: BookingsOverviewState = defaultInitialState) {
  return createStore<BookingsOverviewStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },

    setIn: (path, value) => {
      set(state => setIn(state, path, value) as BookingsOverviewState)
    },

    changeBookingHistoryTab: (tab) => {
      set(state => ({ ...state, bookingHistoryActiveTab: tab }))
    },
  }))
}
